<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid>
            <div class="d-flex mb-4">
                <h2>{{$t('actionListmod.actionList')}}</h2>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    dark
                    small
                    class="mr-2"
                    :to="{ name: 'DailyTask'}"
                >
                    {{ $t('listView') }}
                </v-btn>
                <!-- <v-btn
                    color="primary"
                    dark
                    small
                    class="mr-2"
                    :to="{ name: 'SingleDailyTask', params: { task_id: '12345'}}"
                >
                    Single Task
                </v-btn> -->
            </div>
            <v-card
                elevation="0"
                class="px-5"
                color="transparent"
            >
                <v-card-text>
                    <template>
                        <v-row class="fill-height">
                            <v-col>
                                <v-sheet height="64">
                                    <v-toolbar
                                    flat
                                    >
                                    <v-btn
                                        outlined
                                        class="mr-4 ml-0"
                                        color="primary"
                                        @click="setToday"
                                    >
                                        {{$t('actionListmod.tODAY')}}
                                    </v-btn>
                                    <v-spacer></v-spacer>

                                    <v-btn
                                        fab
                                        text
                                        small
                                        color="grey darken-2"
                                        @click="prev"
                                    >
                                        <v-icon small>
                                        mdi-chevron-left
                                        </v-icon>
                                    </v-btn>
                                    <v-toolbar-title v-if="$refs.calendar">
                                        {{ $refs.calendar.title }}
                                    </v-toolbar-title>
                                    <v-btn
                                        fab
                                        text
                                        small
                                        color="grey darken-2"
                                        @click="next"
                                    >
                                        <v-icon small>
                                        mdi-chevron-right
                                        </v-icon>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-menu
                                        bottom
                                        right
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                color="primary"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <span>{{ $t(typeToLabel[type]) }}</span>
                                                <!-- <v-icon right>
                                                mdi-menu-down
                                                </v-icon> -->
                                            <v-icon>mdi-chevron-down</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="type = 'day'">
                                                <v-list-item-title>{{$t('actionListmod.dAY')}}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="type = 'week'">
                                                <v-list-item-title>{{$t('actionListmod.wEEK')}}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="type = 'month'">
                                                <v-list-item-title>{{$t('actionListmod.mONTH')}}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    </v-toolbar>
                                </v-sheet>
                                <br/>
                                <v-row class="fill-height" no-gutters>
                                    <v-col cols="3" class="pa-2">
                                        <v-btn 
                                            :to="{ name: 'CreateTask'}" 
                                            color="primary" 
                                            class="mb-5" 
                                            block
                                        > 
                                            <v-icon class="mr-3">mdi-calendar-text-outline</v-icon>
                                            <!-- <v-spacer></v-spacer> -->
                                            {{$t('actionListmod.createTask')}}
                                            <v-spacer></v-spacer>
                                            <v-icon>mdi-chevron-down</v-icon>
                                        </v-btn>
                                        <v-date-picker
                                            full-width
                                            v-model="today"
                                            color="primary"
                                            :events="['2022-01-15','2022-01-25']"
                                            event-color="secondary2"
                                            @change="dateChanged"
                                            no-title
                                        ></v-date-picker>

                                        <!-- <v-text-field 
                                            class="mt-5" 
                                            outlined
                                            prepend-inner-icon="mdi-magnify"
                                            dense
                                            placeholder="Search for people"
                                        ></v-text-field>

                                        <v-list
                                            subheader
                                            flat
                                            dense
                                        >
                                        <v-subheader class="title">{{$t('actionListmod.myActivities')}}</v-subheader>

                                        <v-list-item-group
                                            multiple
                                             v-model="selected"
                                        >
                                            <v-list-item dense>
                                                <template v-slot:default="{ active }">
                                                    <v-list-item-action>
                                                        <v-checkbox
                                                            :input-value="active"
                                                            color="primary"
                                                        ></v-checkbox>
                                                    </v-list-item-action>

                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('actionListmod.jhonSmith')}}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </v-list-item>

                                            <v-list-item>
                                                <template v-slot:default="{ active }">
                                                    <v-list-item-action>
                                                        <v-checkbox
                                                            :input-value="active"
                                                            color="primary"
                                                        ></v-checkbox>
                                                    </v-list-item-action>

                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('actionListmod.farmID')}}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </v-list-item>

                                            <v-list-item>
                                                <template v-slot:default="{ active }">
                                                    <v-list-item-action>
                                                        <v-checkbox
                                                            :input-value="active"
                                                            color="primary"
                                                        ></v-checkbox>
                                                    </v-list-item-action>

                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('actionListmod.dateOfEvent')}}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </v-list-item>

                                            <v-list-item>
                                                <template v-slot:default="{ active }">
                                                    <v-list-item-action>
                                                        <v-checkbox
                                                            :input-value="active"
                                                            color="primary"
                                                        ></v-checkbox>
                                                    </v-list-item-action>

                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('actionListmod.actionRequired')}}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </v-list-item>

                                            <v-list-item>
                                                <template v-slot:default="{ active }">
                                                    <v-list-item-action>
                                                        <v-checkbox
                                                            :input-value="active"
                                                            color="primary"
                                                        ></v-checkbox>
                                                    </v-list-item-action>

                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('actionListmod.actionTaken')}}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </v-list-item>

                                            <v-list-item>
                                                <template v-slot:default="{ active }">
                                                    <v-list-item-action>
                                                        <v-checkbox
                                                            :input-value="active"
                                                            color="primary"
                                                        ></v-checkbox>
                                                    </v-list-item-action>

                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('actionListmod.animalEventID')}}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </v-list-item>

                                            </v-list-item-group>
                                        </v-list> -->
                                    </v-col>
                                    <v-col cols="9" class="pa-2">
                                        <v-sheet height="600">
                                            <v-calendar
                                                ref="calendar"
                                                v-model="today"
                                                color="primary"
                                                :events="events"
                                                :event-color="getEventColor"
                                                :type="type"
                                                @click:event="showEvent"
                                                @click:more="viewDay"
                                                @click:date="viewDay"
                                                @change="updateRange"
                                            >
                                             <template #event="event">
                                                 {{ event.eventParsed.input.name }}
                                            </template>
                                            <!-- <template v-slot:day-header="dateObj">
                                                <div style="background-color: red; margin-left: -700px">{{dateObj.day}}</div>
                                            </template> -->
                                            </v-calendar>
                                            <v-menu
                                            v-model="selectedOpen"
                                            :close-on-content-click="false"
                                            :activator="selectedElement"
                                            offset-x
                                            >
                                                <v-card
                                                    color="grey lighten-4"
                                                    min-width="100px"
                                                    width="500"
                                                    flat
                                                >
                                                    <v-toolbar
                                                        :color="selectedEvent.color"
                                                        dark
                                                    >
                                                        <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-btn icon @click="$router.push({ name: 'UpdateTask', params:{task_id:selectedEvent.taskNum}})">
                                                            <v-icon>mdi-pencil</v-icon>
                                                        </v-btn>
                                                         <v-btn icon  @click="gettaskId(selectedEvent.taskNum)">
                                                            <v-icon>mdi-delete</v-icon>
                                                        </v-btn>
                                                        <v-btn icon @click="$router.push({ name: 'SingleDailyTask', params:{task_id:selectedEvent.taskNum}})">
                                                            <v-icon>mdi-dots-horizontal-circle</v-icon>
                                                        </v-btn>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <span v-html="selectedEvent.details"></span>
                                                    </v-card-text>
                                                    <v-card-actions>
                                                    <v-btn
                                                        text
                                                        color="secondary"
                                                        @click="selectedOpen = false"
                                                    >
                                                        {{$t('actionListmod.cANCEL')}}
                                                    </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-menu>
                                        </v-sheet>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        </template>
                </v-card-text>
            </v-card>
        </v-container>
        <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{$t('actionListmod.cONFIRM')}}
        </v-card-title>

        <v-card-text>
          {{$t('actionListmod.sTATEMENT')}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
            @click="dialog = false"
          >
            {{$t('actionListmod.cANCEL')}}
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            v-on:click="deleteItem(id)"
          >
           ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import loading from "@/mixins/LoadingMixin";
export default {
    mounted() {  
        document.title = this.$t("actionList");
        this.$refs.calendar.checkChange()
    },
    watch: {
        
    },
    data: () => ({
        selected: [0,3],
        today: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        type: 'month',
        dialog: false,
        id:"",
        typeToLabel: {
            month: 'Month',
            week: 'Week',
            day: 'Day',
        },
        eventsArray: [
                {
                    "name": "Conference",
                    "start": "2022-01-05 11:45:00",
                    "end": "2022-01-05 12:15:00",
                    "color": "green",
                    "timed": true
                },
                {
                    "name": "Birthday",
                    "start": "2022-01-29 09:30:00",
                    "end": "2022-02-01 05:15:00",
                    "color": "cyan",
                    "timed": false
                },
                {
                    "name": "Travel",
                    "start": "2022-01-18 21:45:00",
                    "end": "2022-01-18 22:30:00",
                    "color": "grey darken-1",
                    "timed": true
                },
                {
                    "name": "Birthday",
                    "start": "2022-01-20 01:45:00",
                    "end": "2022-01-22 01:00:00",
                    "color": "orange",
                    "timed": false
                },
                {
                    "name": "Conference",
                    "start": "2022-01-14 06:15:00",
                    "end": "2022-01-14 08:15:00",
                    "color": "indigo",
                    "timed": true
                },
                {
                    "name": "Party",
                    "start": "2022-01-25 05:30:00",
                    "end": "2022-01-25 07:15:00",
                    "color": "cyan",
                    "timed": true
                },
                {
                    "name": "Meeting",
                    "start": "2022-01-05 03:15:00",
                    "end": "2022-01-05 18:00:00",
                    "color": "green",
                    "timed": false
                },
                {
                    "name": "Meeting",
                    "start": "2022-01-01 17:00:00",
                    "end": "2022-01-02 04:00:00",
                    "color": "deep-purple",
                    "timed": false
                },
            ],
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
        cols: {
            urgent: "red", 
            high: "orange", 
            medium: "cyan", 
            low: "green",
            no: "grey darken-1"
        },
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
        breadcrumbs: [
				{
					text: 'Dashboard',
					disabled: false,
					to: '/',
				},
				{
					text: 'Action List',
					disabled: true,
				},
			],
    }),
    methods: {
        viewDay ({ date }) {
            this.today = date
            this.type = 'day'
        },
        dateChanged(e) {
            this.viewDay({ date: e})
        },
        getEventColor (event) {
            return event.color
        },
        setToday () {
            this.today = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        },
        prev () {
            this.$refs.calendar.prev()
        },
        next () {
            this.$refs.calendar.next()
        },
        showEvent ({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },
        gettaskId(data){
            this.id=data;
            this.dialog=true
        },
        deleteItem(id){
            this.$store.dispatch('deleteRecord', id)
            .then(async (res)=>{
               if (res.success == true) {
            this.dialog=false
            this.events=this.events.filter(item=>{
                return item.taskNum!==id
            })
            this.$notify({
              title: "Task Deleted",
              text: res.message,
              type: "success",
            });
        //    this.$router.push({name: 'ActionListmod'})
          } else {
            this.$notify({
              title: "Task Not Deleted",
              text: res.message,
              type: "error",
            });
          }
            })
            .catch( err => {
                console.log(err)
            })
        },
        updateRange ({ start, end }) {
            console.log("in update range", this.type)

            const startDate = start.date;
            var endDate = null
            if(this.type != 'day') {
                endDate = end.date;
            }
            this.startLoading();

            this.$store.dispatch('getTasksBetweenDates', {startDate, endDate})
            .then((res) => {
                const events = []
                // const eventCount =  res.data.events.num_rows
                // console.log(res.data.events.rows)
                res.data.events.rows.forEach(element => {
                    events.push({
                        name: `${element.name}`,
                        start: `${element.startDate} 01:01:01`,
                        end: `${element.dueDate} 23:59:59`,
                        color: this.cols[element?.priority || "no"],
                        details: element.description,
                        timed: false,
                        taskNum: element.TENumber
                    })
                });
                this.events = events
            })
            .catch( err => {
                console.log(err)
            })
            .finally(()=> {
                this.stopLoading()
            })
        },
        rnd (a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },
    },
    mixins: [loading]
}
</script>
<style lang="scss">
.v-calendar-daily_head-weekday {
 
  text-align: left !important;
  margin-left: 17px;
  margin-top: 15px;
}

.v-calendar-daily_head-day-label {
  text-align: left !important;
  margin-left: 27px;
  margin-bottom: 15px;

}

.v-calendar-daily_head-day-label .v-btn__content {
  font-weight: bold !important;
//   margin-top: -30px;
}

.v-calendar-daily_head-day-label  .v-btn--fab.v-size--default {
  height: 0px;
  width: 0px;
}

.v-calendar.v-calendar-events .v-calendar-weekly__head-weekday {
  margin-right: -1px;
  font-size: 15px;
  font-weight: bold;
  padding: 20px;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
</style>